import React from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { CardActionArea, Grid, Tooltip, Box } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { body1ResponsiveSizes } from "../../../shared/styles/custom-styles";
import { RecommendedPrompt } from "../../settings/types";

type ExampleQuestionCardProps = {
  prompt: RecommendedPrompt;
  handleCardClick: (prompt: RecommendedPrompt) => void;
};

const cardStyle = {
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  maxWidth: 200,
  minWidth: 150,
  margin: "10px",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "primary.main",
  boxShadow: 3,
  bgcolor: "info.main",
  "&:hover": {
    transform: "scale(1.03)",
    transition: "transform 0.05s ease-in-out",
  },
};

export const ExampleQuestionCard = React.memo(
  ({ prompt, handleCardClick }: ExampleQuestionCardProps) => {
    const isAIAssisted = prompt.type === "ai-assisted";

    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Card sx={cardStyle}>
          <CardActionArea
            onClick={() => handleCardClick(prompt)}
            sx={{
              height: "100%",
              width: "100%",
              position: "relative",
            }}
          >
            {isAIAssisted && (
              <Tooltip title="This prompt is recommended based on your historical prompt" placement = "top">
                <Box
                  sx={{
                      position: "absolute",
                      top: 8,
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                      color: "#FFD700", // Gold color for the star
                  }}
                  onClick={(e) => e.stopPropagation()} // Prevent card click when clicking star
                >
                  <StarIcon sx={{ fontSize: "24px" }} />
                </Box>
              </Tooltip>
            )}
            <CardContent>
              <Typography
                variant="body1"
                sx={{
                  color: "info.contrastText",
                  fontSize: body1ResponsiveSizes,
                }}
              >
                {prompt.user_prompt_fe}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    );
  }
);
